/* eslint-disable */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import { Link as RouterLink } from 'react-router-dom';
import editFill from '@iconify/icons-eva/edit-fill';
// material
import { Grid } from '@mui/material';
import ProductlistCard from './ProductlistCard';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';

// ----------------------------------------------------------------------

Productlist.propTypes = {
  products: PropTypes.array.isRequired
};

export default function Productlist({ products, props, type, ...other }) {
  console.log(products);

  React.useEffect(() => {
    try {
      const y = Number(sessionStorage.getItem('productListScrollY'));
      const x = Number(sessionStorage.getItem('productListScrollX'));
      if (!Number.isNaN(y)) {
        const start = Date.now();
        const tryRestore = () => {
          // wait until content height is enough
          const ready = document.body && document.body.scrollHeight > y;
          if (ready) {
            window.scrollTo(Number.isNaN(x) ? 0 : x, y);
            sessionStorage.removeItem('productListScrollY');
            sessionStorage.removeItem('productListScrollX');
          } else if (Date.now() - start < 2000) {
            // retry until 2s
            setTimeout(tryRestore, 50);
          } else {
            // fallback: scroll anyway
            window.scrollTo(Number.isNaN(x) ? 0 : x, y);
            sessionStorage.removeItem('productListScrollY');
            sessionStorage.removeItem('productListScrollX');
          }
        };
        setTimeout(tryRestore, 0);
      }
    } catch (e) {}
  }, []);

  return (
    <Grid container spacing={3} {...other}>
      {products.map((product) => (
        <Grid key={product.id} item xs={12} sm={6} md={2}>
          <ProductlistCard product={product} props={props} type={type} />
        </Grid>
      ))}
    </Grid>
  );
}
